var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "collapse",
        { attrs: { title: "Breve descripción de los servicios solicitados" } },
        [
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: {
                  "custom-messages": {
                    required: "El campo es requerido."
                  },
                  rules: "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg": errors[0],
                              error: errors[0],
                              label:
                                "Por favor explique brevemente los servicios que solicita, por ejemplo: desarrollo profesional para maestros de matemáticas, servicios de evaluación, etc.",
                              maxlength: 3000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.serviceDescription,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "serviceDescription", $$v)
                              },
                              expression: "model.serviceDescription"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2587334738
                )
              })
            : _vm.isReadOnly
            ? _c("div", { staticClass: "my-2" }, [
                _c("div", { staticClass: "my-2" }, [
                  _vm._v(
                    " Por favor explique brevemente los servicios que solicita, por ejemplo: desarrollo profesional para maestros de matemáticas, servicios de evaluación, etc. "
                  )
                ]),
                _c("label", { staticClass: "data-label" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("empty")(_vm.model.serviceDescription)) +
                      " "
                  )
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "collapse",
        { attrs: { title: "Prioridades a entidades gubernamentales" } },
        [
          _c("label", { staticClass: "data-label" }, [
            _vm._v(
              " Indicar si interesa establecer prioridad en la selección de entidades gubernamentales para proveer los servicios. Esta prioridad para la selección solo tendrá lugar cuando la entidad gubernamental cuente con la pericia y capacidad para brindar los servicios que se están solicitando, resultando en ahorros y una mayor eficiencia para el DEPR. "
            )
          ]),
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ validated }) {
                  return [
                    _c("custom-radio", {
                      staticClass: "custom-radio",
                      attrs: {
                        "custom-error-msg": "El campo es requerido.",
                        disabled: _vm.isReadOnly,
                        "is-inline": "",
                        name: "prioritiesGovernmentEntities",
                        options: _vm.hasPrioritiesGovernmentEntitiesOptions
                      },
                      model: {
                        value: _vm.hasPrioritiesGovernmentEntities,
                        callback: function($$v) {
                          _vm.hasPrioritiesGovernmentEntities = $$v
                        },
                        expression: "hasPrioritiesGovernmentEntities"
                      }
                    }),
                    validated &&
                    ![true, false].includes(
                      _vm.hasPrioritiesGovernmentEntities?.value
                    )
                      ? _c("error", {
                          attrs: {
                            message: "El campo es requerido.",
                            variant: "no-border"
                          }
                        })
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("collapse", { attrs: { title: "Cuantía estimada" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md-6" },
            [
              !_vm.isReadOnly
                ? _c("validation-provider", {
                    attrs: { rules: "required|greaterThanZero" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("label", { staticClass: "data-label" }, [
                                _vm._v(
                                  " Cuantía estimada para los servicios solicitados. "
                                )
                              ]),
                              _c(
                                "money",
                                _vm._b(
                                  {
                                    staticClass: "form-control",
                                    class: { "was-Invalidated": errors[0] },
                                    on: {
                                      input: val =>
                                        (_vm.model.estimatedAmount = val)
                                    },
                                    model: {
                                      value: _vm.estimatedAmount,
                                      callback: function($$v) {
                                        _vm.estimatedAmount = _vm._n($$v)
                                      },
                                      expression: "estimatedAmount"
                                    }
                                  },
                                  "money",
                                  _vm.moneyOptions,
                                  false
                                )
                              ),
                              errors[0]
                                ? _c("error", {
                                    attrs: {
                                      message: errors[0],
                                      variant: "no-border"
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2451782155
                    )
                  })
                : _vm.isReadOnly
                ? _c("div", { staticClass: "my-2" }, [
                    _c("div", [
                      _vm._v(
                        " Cuantía estimada para los servicios solicitados. "
                      )
                    ]),
                    _c("label", { staticClass: "data-label" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("price")(_vm.model.estimatedAmount)) +
                          " "
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _c(
        "collapse",
        { attrs: { title: "Estimado del costo" } },
        [
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: {
                  "custom-messages": {
                    required: "El campo es requerido."
                  },
                  rules: "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg": errors[0],
                              error: errors[0],
                              label:
                                "La Unidad Contratante deberá realizar un ejercicio para identificar los posibles costos de cada elemento para los servicios a realizarse con el propósito de obtener una referencia de los precios en el mercado. Deberá en esta sección explicar el ejercicio realizado. Además, podrá incluir anejos de ser necesario. No pueden hacer referencia a ningún nombre de marca o nombre de persona natural o jurídica tanto en los anejos como en este formulario.",
                              maxlength: 3000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.costEstimateDetails,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "costEstimateDetails", $$v)
                              },
                              expression: "model.costEstimateDetails"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1720516566
                )
              })
            : _vm.isReadOnly
            ? _c("div", { staticClass: "my-2" }, [
                _c("div", { staticClass: "my-2" }, [
                  _vm._v(
                    " La Unidad Contratante deberá realizar un ejercicio para identificar los posibles costos de cada elemento para los servicios a realizarse con el propósito de obtener una referencia de los precios en el mercado. Deberá en esta sección explicar el ejercicio realizado. Además, podrá incluir anejos de ser necesario. No pueden hacer referencia a ningún nombre de marca o nombre de persona natural o jurídica tanto en los anejos como en este formulario. "
                  )
                ]),
                _c("label", { staticClass: "data-label" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("empty")(_vm.model.costEstimateDetails)) +
                      " "
                  )
                ])
              ])
            : _vm._e(),
          _vm._t("cost-estimate")
        ],
        2
      ),
      _c("collapse", { attrs: { title: "Vigencia del contrato" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md" },
            [
              !_vm.isReadOnly
                ? _c("validation-provider", {
                    attrs: {
                      "custom-messages": {
                        required: "El campo es requerido."
                      },
                      rules: "required"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-date-picker", {
                                staticClass: "w-100",
                                attrs: {
                                  "custom-error-msg": errors[0],
                                  error: errors[0],
                                  label: "Fecha desde:",
                                  placeholder: "DD/MM/YYYY"
                                },
                                on: { input: _vm.onStartChange },
                                model: {
                                  value: _vm.model.contractStartDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "contractStartDate",
                                      $$v
                                    )
                                  },
                                  expression: "model.contractStartDate"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1914788664
                    )
                  })
                : _vm.isReadOnly
                ? _c("div", { staticClass: "my-2" }, [
                    _c("div", [_vm._v(" Fecha desde: ")]),
                    _c("label", { staticClass: "data-label" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("date")(_vm.model.contractStartDate)) +
                          " "
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 col-md" },
            [
              !_vm.isReadOnly
                ? _c("validation-provider", {
                    attrs: {
                      "custom-messages": {
                        required: "El campo es requerido.",
                        afterStartDate:
                          "La fecha de finalización debe ser posterior a la fecha de inicio."
                      },
                      rules: {
                        required: true,
                        afterStartDate: { start: _vm.model.contractStartDate }
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-date-picker", {
                                staticClass: "w-100",
                                attrs: {
                                  "custom-error-msg": errors[0],
                                  error: errors[0],
                                  label: "Fecha hasta:",
                                  "min-date": _vm.model.contractStartDate
                                    ? new Date(_vm.model.contractStartDate)
                                    : null,
                                  placeholder: "DD/MM/YYYY"
                                },
                                model: {
                                  value: _vm.model.contractEndDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "contractEndDate", $$v)
                                  },
                                  expression: "model.contractEndDate"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2556301699
                    )
                  })
                : _vm.isReadOnly
                ? _c("div", [
                    _c("div", [_vm._v(" Fecha hasta: ")]),
                    _c("label", { staticClass: "data-label" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("date")(_vm.model.contractEndDate)) +
                          " "
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }